
<workflow-no-access [workflowTargetInfo]="workflowTargetInfo"></workflow-no-access>
<div class="container" [hidden]="!workflowTargetInfo.correctRole">
  <div class="row alert-container-block">
    <div class="col">
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row step-description-block">
    <div class="col">
      <div class="float-left">
        <p>Please review the parts to be reordered and deployed</p>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col table-card">
      <div class="row">
        <div class="col">
          <table class="table table-responsive">
            <thead>
              <tr>
                <th>Device Key</th>
                <th>SKU</th>
                <th>Description</th>
                <th>Serial Number</th>
              </tr>
            </thead>
            <tbody>
              <ng-template ngFor let-asset [ngForOf]="assets">
                <tr>
                  <td><b>{{ asset.deviceKey }}</b></td>
                  <td><b>{{ asset.productNumber }}</b></td>
                  <td><b>{{ asset.productDescription }}</b></td>
                  <td><b>{{ asset.serialNumber }}</b></td>
                </tr>
                <tr class="no-top-border no-top-padding" *ngFor="let part of asset.accessories | selectableAccessoryFilter : asset.reorderFullBundle">
                  <td>{{ part.deviceKey }}</td>
                  <td>{{ part.productNumber }}</td>
                  <td>{{ part.productDescription }}</td>
                  <td>{{ part.serialNumber }}</td>
                </tr>
                <tr class="no-top-border no-top-padding" *ngFor="let part of asset.standaloneAccessories | selectableAccessoryFilter : asset.reorderFullBundle">
                  <td>{{ part.deviceKey }}</td>
                  <td>{{ part.productNumber }}</td>
                  <td>{{ part.productDescription }}</td>
                  <td>{{ part.serialNumber }}</td>
                </tr>
              </ng-template>
              <tr *ngIf="!assets.length">
                <td>
                  <p class="text-center empty-table-message">There are no Assets to display.</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>